import { SelectItem } from 'primeng/components/common/api';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-action-details',
  templateUrl: './campaign-action-details.component.html',
  styleUrls: ['./campaign-action-details.component.css']
})
export class CampaignActionDetailsComponent implements OnInit {
  @Input() viewActionGenerated: any;
  @Input() touchPointOfflineList: SelectItem[];
  @Input() touchPointOnlineList: SelectItem[];
  @Input() isMessageInstancePresent: boolean;
  @Input() isBasketPresent: boolean;
  @Input() isCampaignConstraintExclusionPresent: boolean;
  @Input() isCampaignConstraintValidationPresent: boolean;
  @Input() cardHolderType: string;
  @Input() actionStatus: string;
  @Input() dynamicCoupon: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-action-details/campaign-action-details.component.ts